import { useEffect, useState } from "react";
import { X, Copy, Check, Sparkles } from "lucide-react";
import { api } from "../lib/api";
import { usePirate } from "../lib/PirateContext";
import { toast } from "sonner";

const STORAGE_KEY = "desashop_newsletter_shown";

export default function NewsletterModal() {
    const [show, setShow] = useState(false);
    const [email, setEmail] = useState("");
    const [code, setCode] = useState("");
    const [loading, setLoading] = useState(false);
    const [copied, setCopied] = useState(false);
    const { award } = usePirate();

    useEffect(() => {
        const seen = localStorage.getItem(STORAGE_KEY);
        if (!seen) {
            const t = setTimeout(() => setShow(true), 4000);
            return () => clearTimeout(t);
        }
    }, []);

    function close() {
        localStorage.setItem(STORAGE_KEY, "1");
        setShow(false);
    }

    async function submit(e) {
        e.preventDefault();
        if (!email || !email.includes("@")) {
            toast.error("Inserisci una email valida");
            return;
        }
        setLoading(true);
        try {
            const { data } = await api.post("/newsletter", { email });
            setCode(data.code);
            localStorage.setItem("desashop_discount_code", data.code);
            if (!data.already_subscribed) {
                award("newsletter");
            }
            toast.success(data.message || "Codice sconto generato!");
        } catch (e) {
            const msg = e?.response?.data?.detail || "Errore. Riprova.";
            toast.error(typeof msg === "string" ? msg : "Errore");
        } finally {
            setLoading(false);
        }
    }

    function copyCode() {
        navigator.clipboard.writeText(code);
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
    }

    if (!show) return null;

    return (
        <div className="fixed inset-0 z-[60] flex items-center justify-center p-4 bg-ink/70" data-testid="newsletter-modal">
            <div
                className="relative w-full max-w-2xl bg-parchment border-2 border-ink shadow-manga-lg overflow-hidden"
                style={{
                    backgroundImage:
                        "linear-gradient(rgba(244, 238, 221, 0.92), rgba(244, 238, 221, 0.92)), url('https://images.pexels.com/photos/18799892/pexels-photo-18799892.jpeg')",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                }}
            >
                <div className="tape -top-2 left-12" />
                <div className="tape -top-2 right-12 rotate-[6deg]" />

                <button
                    onClick={close}
                    aria-label="Chiudi"
                    className="absolute top-3 right-3 w-9 h-9 border-2 border-ink bg-parchment flex items-center justify-center hover:bg-bounty hover:text-parchment"
                    data-testid="newsletter-close-btn"
                >
                    <X size={16} />
                </button>

                <div className="p-8 md:p-12 text-center">
                    <div className="font-hand text-3xl text-bounty -rotate-2 inline-block">
                        Avviso ai pirati
                    </div>
                    <h2 className="font-display text-5xl md:text-6xl tracking-tight mt-2">
                        UNISCITI ALLA CIURMA
                    </h2>
                    <p className="mt-3 text-base max-w-md mx-auto text-ink/80">
                        Iscriviti alla newsletter e ricevi un{" "}
                        <span className="font-bold text-bounty">codice 10% di sconto</span>,{" "}
                        <span className="font-bold">+100 XP</span> e{" "}
                        <span className="font-bold">+500 Berry</span> per iniziare il viaggio.
                    </p>

                    {!code ? (
                        <form
                            onSubmit={submit}
                            className="mt-7 flex flex-col sm:flex-row gap-3 max-w-md mx-auto"
                        >
                            <input
                                type="email"
                                required
                                placeholder="email@nave.com"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                className="input-manga flex-1"
                                data-testid="newsletter-email-input"
                            />
                            <button
                                type="submit"
                                disabled={loading}
                                className="btn-manga btn-manga-red whitespace-nowrap"
                                data-testid="newsletter-submit-btn"
                            >
                                {loading ? "..." : "ricevi sconto"}
                            </button>
                        </form>
                    ) : (
                        <div className="mt-7 max-w-md mx-auto" data-testid="newsletter-code-display">
                            <div className="font-hand text-xl text-ink/70">
                                il tuo codice
                            </div>
                            <div className="mt-2 bounty-card p-5 flex items-center justify-between">
                                <span className="font-mono text-2xl tracking-widest text-bounty">
                                    {code}
                                </span>
                                <button
                                    onClick={copyCode}
                                    className="btn-manga"
                                    data-testid="newsletter-copy-code-btn"
                                >
                                    {copied ? (
                                        <Check size={16} />
                                    ) : (
                                        <Copy size={16} />
                                    )}
                                </button>
                            </div>
                            <p className="text-xs font-mono mt-3 text-ink/60">
                                Inseriscilo al checkout per ottenere 10% di sconto
                            </p>
                            <button
                                onClick={close}
                                className="mt-5 btn-manga btn-manga-ghost"
                            >
                                Continua a esplorare
                            </button>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}
